import React from "react";
import styled from "styled-components";

import * as Color from "~/Color";
import { Info } from "~/Icon";
import * as Layout from "~/Layout";
import * as Shadow from "~/Shadow";
import { Timeline } from "~/Timeline";
import * as Tooltip from "~/Tooltip";
import * as Typography from "~/Typography";

export function Menu({ children }: { readonly children?: Component.Children }) {
  return <Menu.Container>{children}</Menu.Container>;
}

export namespace Menu {
  export const zIndex = (): number => Timeline.Event.zIndex() + 2;
  export const width = () => "220px" as const;

  export const Container = styled(Layout.Section.Component)`
    z-index: ${() => zIndex()};
    position: absolute;
    top: ${() => Timeline.Marker.height()};
    left: 0;
    bottom: ${() =>
      `calc(${Timeline.Marker.height()} + ${Timeline.Scroll.height()} + ${Timeline.Scroll.paddingBottom()})`};

    width: ${() => width()};
    overflow: hidden;

    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;

    ${() => Shadow.Box.styles(Shadow.medium())};
  `;

  export const Title = ({
    Icon,
    children,
  }: {
    readonly Icon?: Component;
    readonly children?: Component.Children;
  }) => (
    <Typography.H3.Component>
      {children}
      {Icon && (
        <Layout.Inline.Component left>
          <Icon />
        </Layout.Inline.Component>
      )}
    </Typography.H3.Component>
  );

  export const Explanation: Component = ({
    children,
  }: {
    readonly children?: Component.Children;
  }) => (
    <Tooltip.Component Content={() => <>{children}</>}>
      <Info faded />
    </Tooltip.Component>
  );

  export type Item = {
    readonly rowCount?: number;
    readonly children?: Component.Children;
  };

  export function Item({ children, ...props }: Item) {
    return <Item.Container {...props}>{children}</Item.Container>;
  }

  export namespace Item {
    export const Container = styled.div<Item>`
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 ${() => Layout.Block.padding()};
      width: ${() => width()};
      height: ${({ rowCount = 1 }) =>
        `calc(${rowCount} * ${Timeline.Row.height()})`};

      border-bottom: 1px solid ${Color.veryWhiteGrey()};

      &:nth-of-type(even) {
        background: ${Color.almostWhite()};
      }
    `;
  }
}
